var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"text-h5 font-weight-bold pl-4"},[_vm._v("Klasus - klasifikacije proizvoda po djelatnostima Republike Hrvatske")]),_c('KlasusSearch'),_c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',[_vm._v(" Odaberite razinu djelatnosti od 1 do 5 ")]),_c('KlasusLevel1')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }